import { gql } from '@apollo/client';

export const EMPLOYEES = gql`
  query employees($limit: Int, $page: Int, $search: EmployeeSearchInput) {
    client {
      id
      employees(limit: $limit, page: $page, search: $search) {
        totalCount
        list {
          id
          commonId
          personalId
          officeId
          staffCode
          firstName
          lastName
          firstNameKana
          lastNameKana
          email
          gender
          joinedAt
          retiredAt
          officeName
          employmentType
          occupation
          groups
          position
        }
      }
    }
  }
`;

export interface EmployeesQueryVariables {
  page?: number | null;
  limit?: number | null;
  search?: EmployeeSearchInput | null;
}

export type SortOrder = 'asc' | 'desc';

export type SortColumn = 'staff_code' | 'full_name_kana' | 'joined_at';

interface EmployeeSearchInput {
  status?: string | null;
  statuses?: string[] | null;
  q?: string | null;
  sortOrder?: SortOrder | null;
  sortColumn?: SortColumn | null;
  offices?: string[] | null;
  groups?: string[] | null;
  positions?: string[] | null;
  employmentTypes?: string[] | null;
}

export interface Employees {
  client: {
    employees: {
      totalCount: number;
      list: Employee[];
    };
  };
}

export interface Employee {
  id: string;
  commonId?: number;
  personalId: string;
  officeId?: number;
  staffCode?: string;
  firstName?: string;
  lastName?: string;
  firstNameKana?: string;
  lastNameKana?: string;
  email?: string;
  gender?: number;
  joinedAt?: string;
  retiredAt?: string;
  officeName?: string;
  employmentType?: string;
  occupation?: string;
  groups?: string[];
  position?: string;
}
